import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'
import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'

const ID = 'vimeo-third-party-glyph-icon'

export function VimeoSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 32 32">
      <g>
        <path
          fillRule="evenodd"
          d="M31.84 8.72c-1.788 10.104-11.778 18.657-14.784 20.612-3.006 1.95-5.747-.787-6.741-2.853-1.138-2.36-4.55-15.15-5.442-16.211-.894-1.061-3.574 1.06-3.574 1.06L0 9.619S5.442 3.1 9.583 2.282c4.392-.86 4.385 6.764 5.443 10.998 1.02 4.098 1.707 6.437 2.6 6.437s2.599-2.28 4.466-5.784c1.872-3.505-.08-6.6-3.737-4.4C19.818.74 33.629-1.376 31.84 8.72Z"
          clipRule="evenodd"
        />
      </g>
    </symbol>
  )
}

const VimeoStandaloneContent = standalone(VimeoSymbol, ID)

export const Vimeo = styled(function VimeoStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-vimeo">
      <VimeoStandaloneContent />
    </Icon>
  )
})``

export const VimeoLightweight = styled(function VimeoComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-vimeo">
      {lightweight(ID)}
    </Icon>
  )
})``
